import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  rootUri = (environment.ktRootUri) ? environment.ktRootUri : "";

  constructor(private http: HttpClient) { }

  getClientDetails(id: number): Observable<ClientDetailsResponse> {
    return this.http.get<ClientDetailsResponse>(this.rootUri + `/api/client/${id}`);
  }

  getClientVenues(id: number): Observable<ClientVenue[]> {
    return this.http.get<ClientVenue[]>(this.rootUri + `/api/venue/by-client/${id}`);
  }

  updateClientDetails(id: number, data: ClientEditDetails): Observable<ClientDetailsResponse> {
    return this.http.post<ClientDetailsResponse>(this.rootUri + `/api/client/${id}/edit`, data);
  }

  newClient(data: ClientEditDetails): Observable<ClientDetailsResponse> {
    return this.http.post<ClientDetailsResponse>(this.rootUri + `/api/client/new`, data);
  }
}
